import React from 'react';
import { Confirmation } from '@alucio/lux-ui';
import { useAttendeeShareScreen } from '@alucio/video';
const ConfirmationAttendeeShareScreen = () => {
    const { askForShare, shareHandler } = useAttendeeShareScreen();
    return (askForShare ? React.createElement(Confirmation, { showCloseButton: true, text: "The host has asked to share your screen.", header: "Start screen share", successText: "Share screen", cancelText: "Cancel", onSuccess: () => shareHandler(true), onCancel: () => shareHandler(false) }) : null);
};
export default ConfirmationAttendeeShareScreen;
//# sourceMappingURL=ShareScreen.js.map